import BreadCrumb from "../../Components/Common/BreadCrumb";
import React, { useEffect } from "react";
import { Container, Row, Spinner } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import Widget from "./Widget";
import RecentComment from "./RecentComment";
import Device from "./Device";
import RecentArticleTable from "./RecentArticleTable";
import RecentWriterTable from "./RecentWriterTable";

import {
  getServerStats,
  getViewsPerMonth,
  getLastComments,
  getWritersStats,
  getSubcategoriesStats,
  getTopPosts,
  getProfilesPostsStats,
  getLastPosts,
} from "../../slices/12-DashboardAnalytics/thunk";
import SubcategoriesStats from "./SubcategoriesStats";
import TopPostsTable from "./TopPostsTable";
import ProfilesPostsStats from "./ProfilesPostsStats";
import LastPostsTable from "./LastPostsTable";

const DashboardBlog = () => {
  document.title = "Post Dashboard";
  const { serverStats, viewsPerMonth, lastComments, writersStats, postsByDay, subcategoriesStats, topPosts, profilesPostsStats, lastPosts, loading } = useSelector((state) => state.dashboardAnalytics);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getServerStats());
  //   dispatch(getViewsPerMonth());
  //   dispatch(getLastComments());
  //   dispatch(getWritersStats());
  //   dispatch(getSubcategoriesStats());
  //   dispatch(getTopPosts());
  //   dispatch(getProfilesPostsStats());
  //   dispatch(getLastPosts());
  // }, [dispatch]);
  // console.log("Server Stats:", serverStats);
  // console.log("Views Per Month:", viewsPerMonth);
  // console.log("Last Comments:", lastComments);
  // console.log("Writers Stats:", writersStats);
  // console.log("Subcategories Stats:", subcategoriesStats);
  // end here
  // console.log("Top Posts:", topPosts);
  // console.log("Profiles Posts Stats:", profilesPostsStats);
  // console.log("Last Posts:", lastPosts);
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "300px" }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="مقالات" pageTitle="لوحة التحكم" /> */}

          {/* <Row>
            <Widget serverStats={serverStats} viewsPerMonth={viewsPerMonth} lastComments={lastComments} />
            <RecentWriterTable writersStats={writersStats} />
            <SubcategoriesStats subcategoriesStats={subcategoriesStats} />
            <TopPostsTable topPosts={topPosts} />
            <ProfilesPostsStats
              profilesPostsStats={profilesPostsStats}
              totalCount={profilesPostsStats.length}
            />
            <LastPostsTable lastPosts={lastPosts} />
          </Row> */}

          <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{ minHeight: "60vh" }}
          >
            <h2 className="mb-3">🚧 قريبًا</h2>
            <p className="text-muted">
              هذه الصفحة قيد التطوير وسيتم إطلاقها قريبًا
            </p>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardBlog;